<template>
	<lcsj-dialog v-model="showEditVisible" :title="title" :modal="false" width="80%" @close="closeDialog()" cancel-text="取消" confirm-text="保存" :confirm-loading="isSubmitting" @confirm="handleSaveClick"> <div class="main_bg">
			<div class="item_info border_Warningcolor">
				<div class="item_title">
					<div class="title">申购单信息</div>
					<div class="btnDiv"></div>
				</div>
				<div class="formDiv">
					<el-form label-position="right" :inline="true" label-width="80px">
						<el-form-item label="所属门店">
							<el-select v-model="editForm.storeKeyId" placeholder="请选择门店" clearable size="small" filterable style="width: 200px">
								<el-option v-for="item in storeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="备注">
							<el-input v-model="editForm.remark" style="width: 500px" placeholder="请输入备注" type="textarea" />
						</el-form-item>
					</el-form>
				</div>
			</div>
			<div class="item_info border_Green">
				<div class="item_title">
					<div class="title">商品信息</div>
					<div class="btnDiv">
						<el-button type="primary" size="mini" icon="el-icon-plus" @click="handleChooseProductType">添加商品</el-button>
					</div>
				</div>
				<el-table class="lcsj-data-table" :cell-class-name="$moneyCellClass" :data="productTableData" style="width: 100%" border :header-cell-style="{ textAlign: 'center' }" :cell-style="{ textAlign: 'center' }">
					<el-table-column prop="rowNumber" label="序号" width="60"></el-table-column>
					<el-table-column prop="typeName" label="类型" width="180"></el-table-column>
					<el-table-column prop="productName" label="系列" width="220"></el-table-column>
					<el-table-column prop="specification" label="商品名称"></el-table-column>
					<el-table-column prop="productBrand" label="商品品牌" width="255">
						<template #default="scope">
							<el-input v-model="scope.row.productBrand" placeholder="请输入商品品牌" size="small" type="textarea" rows="2"></el-input>
						</template>
					</el-table-column>
					<el-table-column prop="quantity" label="数量" width="155">
						<template #default="scope">
							<el-input-number v-model.number="scope.row.quantity" placeholder="请输入数量" size="small" :min="0" :step="1"></el-input-number>
						</template>
					</el-table-column>
					<el-table-column prop="unit" label="单位" width="70"></el-table-column>
					<el-table-column prop="remark" label="备注" width="255">
						<template #default="scope">
							<el-input v-model="scope.row.remark" placeholder="请输入备注" size="small" type="textarea" rows="2"></el-input>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		
	</lcsj-dialog>
</template>

<script>
import { SaveStoreSubscription, GetStoreSubscriptionDetail } from "@/api/productApi.js";
export default {
	props: {
		storeList: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
		isSubmitting: false, // 提交中（防重复提交）
			showEditVisible: false,
			loading: false,
			title: "申购单详情",
			editForm: {
				keyId: "",
				storeKeyId: "",
				remark: "",
				dtls: []
			},
			productTableData: []
		};
	},
	created() {},
	mounted() {},
	components: {},
	methods: {
		// 关联用户
		showEdit(row) {
			this.editForm = {
				keyId: "",
				storeKeyId: "",
				remark: "",
				dtls: []
			};
			this.productTableData = [];
			if (row == null || row == undefined || row === "undefined") {
				this.title = "创建申购单";
			} else {
				GetStoreSubscriptionDetail({
					keyId: row.keyId
				}).then((res) => {
					if (res.code == 1) {
						this.editForm.keyId = res.data.keyId;
						this.editForm.storeKeyId = res.data.storeKeyId;
						this.editForm.remark = res.data.remark;
						this.productTableData = [];
						if (res.data.dtls != null && res.data.dtls.length > 0) {
							var index = 1;
							res.data.dtls.forEach((item) => {
								this.productTableData.push({
									rowNumber: index++,
									productKeyId: item.productTypeInfo.keyId,
									typeName: item.productTypeInfo.typeName,
									productName: item.productTypeInfo.productName,
									specification: item.productTypeInfo.specification,
									quantity: item.quantity,
									unit: item.productTypeInfo.unit,
									remark: item.remark,
									productBrand: item.productBrand
								});
							});
						}
						this.title = "修改申购单";
					} else {
						this.$message.error(res.msg);
					}
				});
			}
			this.showEditVisible = true;
		},
		// 关闭编辑、增加弹出框
		closeDialog() {
			this.editForm = {
				keyId: "",
				storeKeyId: "",
				remark: "",
				dtls: []
			};
			this.showEditVisible = false;
		},
		// 保存
		handleSaveClick() {
			if (!this.editForm.storeKeyId) {
				this.$message.error("请选择门店");
				return;
			}
			if (this.productTableData.length == 0) {
				this.$message.error("请添加商品");
				return;
			}
			var params = {
				keyId: this.editForm.keyId,
				storeKeyId: this.editForm.storeKeyId,
				remark: this.editForm.remark
			};
			params.dtls = [];
			this.productTableData.forEach((item) => {
				params.dtls.push({
					productTypeKeyId: item.productKeyId,
					quantity: item.quantity,
					remark: item.remark,
					productBrand: item.productBrand
				});
			});
			SaveStoreSubscription(params).then((res) => {
				if (res.code == 1) {
					this.$message.success("保存成功");
					this.closeDialog();
					this.$parent.getListData();
				} else {
					this.$message.error(res.msg);
				}
			});
		},
		// 选择商品类型
		ChooseProductType(val) {
			if (val == null || val == undefined || val === "undefined") {
				this.$message.error("请选择商品类型");
				return;
			}
			var index = 1;
			val.forEach((item) => {
				this.productTableData.push({
					rowNumber: index++,
					productKeyId: item.keyId,
					typeName: item.typeName,
					productName: item.productName,
					specification: item.specification,
					quantity: 1,
					remark: "",
					unit: item.unit,
					productBrand: ""
				});
			});
		},
		// 选择商品类型
		handleChooseProductType() {
			if (!this.editForm.storeKeyId) {
				this.$message.error("请选择门店");
				return;
			}
			this.$parent.showProductTypeSelect(this.editForm.storeKeyId);
		}
	}
};
</script>
<style scoped>
.main_bg {
	padding: 10px;
	margin-top: -15px;
}

.formDiv {
	border: 1px solid var(--app-border);
	padding: 10px;
	border-radius: 5px;
}

.item_info {
	border-left: 5px solid var(--app-primary-hover);
	padding: 5px 10px;
	border-radius: 5px;
	margin-bottom: 15px;
	border: 2px solid var(--app-border);
}

.border_Warningcolor {
	border-left: 5px solid var(--app-warning);
}

.border_Green {
	border-left: 5px solid var(--app-success);
}

.item_title {
	display: flex;
	width: 100%;
	font-weight: 700;
	font-size: 1rem;
	margin-bottom: 10px;
	justify-content: space-between;
}

.item_title .title {
	display: inline-block;
	unicode-bidi: isolate;
}

.item_title .btnDiv {
	display: block;
	unicode-bidi: isolate;
	word-break: break-all;
}
</style>
